import ApiService from '@shared/services/api.service';
const baseModulePath = '/traffic_config';
const TrafficConfigService = {
  fetchList: async () => ApiService.get(`${baseModulePath}/with_current`),
  failOverTraffic: async (id) => ApiService.post(`${baseModulePath}/${id}/failover`, {}),
  fallbackTraffic: async (id) => ApiService.post(`${baseModulePath}/${id}/fallback`, {}),
  // updateAutoFailoverSchedule(bodyParams) {
  //   return ApiService.put('/traffic_config', bodyParams);
  // },
  updateAutoFailoverSchedule(id, bodyParams) {
    return ApiService.put(`${baseModulePath}/${id}/auto_failover_schedule`, bodyParams);
  },
  updateAutoFailoverStatus(id, bodyParams) {
    return ApiService.put(`${baseModulePath}/${id}/auto_failover_status`, {"traffic_auto_failover": bodyParams})
  }
};

export default TrafficConfigService;
